'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markMessageReadByVisitor = markMessageReadByVisitor;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _wrappedPortalIdParser = require('../../utils/wrappedPortalIdParser');

var _wrappedPortalIdParser2 = _interopRequireDefault(_wrappedPortalIdParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIVECHAT_API_PREFIX = 'livechat/v1';

function markMessageReadByVisitor(_ref) {
  var threadId = _ref.threadId,
      sessionId = _ref.sessionId,
      message = _ref.message;

  var messageId = (0, _commonMessageFormatGetters.getMessageIdForCmf)(message);

  return _noAuthApiClient2.default.post(LIVECHAT_API_PREFIX + '/visitorReadThread/thread/' + threadId + '/message/' + messageId, {
    query: {
      portalId: (0, _wrappedPortalIdParser2.default)('markMessageReadByVisitor client'),
      sessionId: sessionId
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./js/threads/clients/markMessageReadByVisitor.js
// module id = 604
// module chunks = 2 3